export default {
	//在浏览器不打开，直接下载文件
	downFile(url) {
		const link = document.createElement('a');
		// link.target = '_blank' //如果该值为‘_self'该行可忽略
		link.target = '_self' //如果该值为‘_self'该行可忽略
		link.style.display = 'none';
		link.href = url; //所下载文件的网络地址
		// link.download = fileName; //下载成功后保存的文件名
		document.body.appendChild(link);
		link.click();
		link.remove();
	},
	//关闭网页
	closePage() {
		var userAgent = navigator.userAgent;
		if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
			window.open('', '_self').close()
		} else {
			window.opener = null;
			window.open("about:blank", "_self");
			window.close();
		}
	},
	//创建a标签，用于下载，访问
	createA(url, filename) {
		const link = document.createElement('a');
		// link.target = '_blank' //如果该值为‘_self'该行可忽略
		link.target = '_self' //如果该值为‘_self'该行可忽略
		link.style.display = 'none';
		link.href = url; //所下载文件的网络地址
		link.download = filename; //下载成功后保存的文件名
		document.body.appendChild(link);
		link.click();
		link.remove();
	},
	//创建a标签，用于下载，访问
	//同源下载修改名称，跨域不修改
	downloadFile(url, filename) {
		const link = document.createElement('a');
		link.style.display = 'none';
		// 设置下载地址
		link.setAttribute('href', url);
		// 设置文件名
		link.setAttribute('download', filename);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	},
	//下载文件，修改下载文件名称
	//后台iis需要设置跨域访问 Access-Control-Allow-Origin：*
	downloadFile_CORS(url, filename) {
		fetch(url).then((res) => {
			res.blob().then((blob) => {
				const url = window.URL.createObjectURL(blob)
				const a = document.createElement('a')
				a.href = url
				a.download = filename
				a.click()
				window.URL.revokeObjectURL(url)
			})
		})
	},
	downFile_byte(byteData, fileName) {
		// 创建临时 URL 并触发下载
		const url = window.URL.createObjectURL(new Blob([byteData]));
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', fileName); // 设置文件名
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url); // 释放内存
	}
}